import React from "react";
import noDataFound from "../../assets/images/nodatafound.png";

const Nodata = () => {
  return (
    <div className="no-data-found-dashboard">
      <img src={noDataFound} alt="noDataFound" />
      <h3 className="text-black mt-2">Data Not Found</h3>
    </div>
  );
};

export default Nodata;
